import React, { ReactElement } from 'react'
import * as styles from 'src/components/framework/icons/material-icon.module.scss'
import { Colors } from 'src/shared/colors'

interface Props {
  icon: MaterialIconRef
  size: number
  color: Colors
}

export const MaterialIcon: React.FC<Props> = ({ icon, size, color }) => {
  const customStyles: React.CSSProperties = {
    // @ts-ignore
    '--material-icon-fill': color,
    '--material-icon-size': `${size}px`,
  }
  return (
    <>
      <svg
        className={styles.materialIcon}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style={customStyles}
      >
        <use href={`#${icon}`} />
      </svg>
    </>
  )
}

export enum MaterialIconRef {
  Locker = 'icon-locker',
  Close = 'icon-close',
  Done = 'icon-done',
  ArrowRight = 'icon-arrow-right',
  Search = 'icon-search',
}
